import * as React from 'react';
import { UIHeading1, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IAboutSdelkaLayoutProps extends React.PropsWithChildren {
  title: string;
  description: string;
}

export const AboutSdelkaLayout: React.FC<IAboutSdelkaLayoutProps> = ({ title, description, children }) => {
  return (
    <section>
      <div className={styles['heading']}>
        <UIHeading1 as="h2" color="text-primary-default">
          {title}
        </UIHeading1>

        <UIText1 color="text-primary-default">{description}</UIText1>
      </div>

      <div className={styles['wrapper']}>{children}</div>
    </section>
  );
};
